import * as React from 'react';

import { Box, IconSearch, TextInput } from '@tocktix/pantry';

interface UserSearchProps {
  query: string;
  onQueryChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const inputStyles: React.CSSProperties = {
  fontSize: '16px',
  letterSpacing: '-0.25px',
};

const UserSearch: React.FunctionComponent<UserSearchProps> = ({ query, onQueryChanged }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      borderRadius="round"
      bgColor="surfaceDefault"
      border="borderDefault"
      style={{ height: '44px', overflow: 'hidden' }}
    >
      <TextInput
        id="query"
        name="query"
        aria-labelledby="search-icon"
        placeholder="Search by name, phone number, or email (min 3 characters)"
        value={query}
        onChange={onQueryChanged}
        startElement={
          <IconSearch id="search-icon" aria-label="Search for user" size={200} color="fgSubtle" />
        }
        fullWidth
        style={inputStyles}
      />
    </Box>
  );
};

export default UserSearch;
